import { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";

import { api } from "../api";

export function LegacyDecisionRedirect() {
  const { id = "" } = useParams();
  const [location, setLocation] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    void api<{ location: string }>(
      `/api/guides/legacy/${encodeURIComponent(id)}`,
    )
      .then((result) => setLocation(result.location))
      .catch(() => setFailed(true));
  }, [id]);
  if (location) return <Navigate to={location} replace />;
  return (
    <div className="page-section">
      <div className="container">
        {failed ? (
          <div className="alert alert-error" role="alert">
            The legacy guide link could not be resolved.
          </div>
        ) : (
          <div className="loading-block" role="status">
            Redirecting to the preserved guide…
          </div>
        )}
      </div>
    </div>
  );
}
